import { DownloadOutlined, SaveOutlined, SearchOutlined, ArrowLeftOutlined, SendOutlined, EditOutlined, PrinterOutlined, PlusOutlined, LockOutlined, ExpandOutlined, CompressOutlined, UploadOutlined, FileExcelOutlined, InboxOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Card, Col, DatePicker, Form, Input, Modal, Row, Space, Tabs} from "antd";
import { useEffect, useState } from "react";
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { dateCommon, formatVND } from '../../helpers/common';
import { BaoHiem, ChiTietBaoHiem } from "../../models/baohiem/BaoHiem";
import { layDanhMucNhomNhanSu } from '../../services/danhmuc';
import { NhomNhanSu } from '../../models/danhmuc/DanhMuc';
import TableBaoHiem from '../../modules/insurance/TableBaoHiem';
import { LayThongTinBaoHiem, XuatExcelBaoCao, duyetBaoHiemXaHoi, importFileBaoHiem, layChiTietBaoHiem, luuDuLieuBaoHiem, taiBaoHiemBoSungTheoListNhanVien, taiDuLieuBaoHiem } from '../../services/baohiem';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import PrintBHXH from './PrintBHXH';
import React from 'react';
import { useReactToPrint } from 'react-to-print';
import dayjs from 'dayjs';
import NhanSuNopBaoHiemTableModal from './NhanSuNopBaoHiemTableModal';
import { Links } from '../../helpers/Links';

const XemChiTietBaoHiem = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [reloadPage, setReloadPage] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [idBaoHiem, setIdBaoHiem] = useState<number>(0);
    const [baoHiem, setBaoHiem] = useState<BaoHiem>();
    const [total, setTotal] = useState<number>(0);
    const [totalDV, setTotalDV] = useState<number>(0);
    const [totalLD, setTotalLD] = useState<number>(0);
    const [totalCD, setTotalCD] = useState<number>(0);
    const dispatch = useDispatch();
    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowImportModal, setIsShowImportModal] = useState(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [danhSachChiTiet, setDanhSachChiTiet] = useState<Array<ChiTietBaoHiem>>([]);
    const [showModalDSNV, setShowModalDSNV] = useState<'NQL' | 'NLD' | null>(null);
    const [ghiChu, setGhiChu] = useState<string>("");
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [dsNhomNhanSu, setDsNhomNhanSu] = useState<Array<NhomNhanSu>>([]);
    const [form] = Form.useForm();

    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await XuatExcelBaoCao(idBaoHiem);
            let link = document.createElement('a');
            link.download = `BaoHiemXaHoi.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo không thành công. Vui lòng thử lại");
        }
        
        dispatch(hideLoadingScreen());
    }
    const layDsChiTiet = async () => {
        dispatch(showLoadingScreen());
        var rs = await layChiTietBaoHiem(idBaoHiem, "");
        setDanhSachChiTiet(rs);
        dispatch(hideLoadingScreen());
    }

    const handleLoadData = async () => {
        dispatch(showLoadingScreen());
        var rs = await taiDuLieuBaoHiem(idBaoHiem);
        setDanhSachChiTiet(rs);
        dispatch(hideLoadingScreen());
    }

    const handleImportExcel = async () => {
        if (!fileUpload) {
            toast.warning("Vui lòng chọn file Excel để import");
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const rs = await importFileBaoHiem(idBaoHiem, fileUpload);
            setDanhSachChiTiet(rs);
            setIsShowImportModal(false);
            setFileUpload(null);
            toast.success("Import dữ liệu BHXH thành công");
        } catch (e: any) {
            toast.error(e?.message || "Import dữ liệu BHXH không thành công");
        }
        dispatch(hideLoadingScreen());
    }

    const onSubmitNhanVienTableModal = async (data: Array<ChiTietBaoHiem>) => {
        dispatch(showLoadingScreen());
        var rs = await taiBaoHiemBoSungTheoListNhanVien(idBaoHiem, data.map(x => x.idNhanVien));
        setDanhSachChiTiet([...danhSachChiTiet, ...rs]);
        dispatch(hideLoadingScreen());
    }

    const monthFormat = ["MM/YYYY", "MMYYYY"];
    const handleSaveData = async () => {
        dispatch(showLoadingScreen());
        try {
            const thangApDungValue = form.getFieldValue('thangApDung');
            const adjustedThangApDung = thangApDungValue && thangApDungValue.isValid && thangApDungValue.isValid()
                ? thangApDungValue.clone().startOf('day').add(1, 'month')
                : null;
            var request = {
                id: idBaoHiem,
                thangApDung: adjustedThangApDung,
                ghiChu: ghiChu,
                chiTiet: danhSachChiTiet
            }
            await luuDuLieuBaoHiem(request);
            toast.success("Lưu tính BHXH thành công");
            setReloadPage(true);
        } catch (e: any) {
            toast.error(e?.message || "Lưu tính BHXH không thành công");
        }

        dispatch(hideLoadingScreen());
    }

    const duyetBHXHThang = async () => {
        dispatch(showLoadingScreen());
        try {
            await duyetBaoHiemXaHoi(idBaoHiem);
            toast.success("Duyệt số liệu BHXH thành công");
            var d: any = {
                ...baoHiem,
                trangThai: 1
            };
            setBaoHiem(d)
        } catch (e) {

        }
        dispatch(hideLoadingScreen());
    }

    const timKiemBaoHiem = async (idBH: number) => {
        dispatch(showLoadingScreen());
        var rs = await LayThongTinBaoHiem(idBH);
        await layDsChiTiet();
        setBaoHiem(rs)
        setGhiChu(rs.ghiChu || "")
        form.setFieldsValue({
            thangApDung: dayjs(dateCommon.formatDate(rs.thangApDung), "dd /MM/ YYYY"),
        })
        dispatch(hideLoadingScreen());
    }

    const search = () => {
        setSearchQuery(tuKhoa);
    }

    const loadNhomNhanSu = async () => {
        try {
            const data = await layDanhMucNhomNhanSu();
            data.sort((a: any, b: any) => (a.thuTu || 0) - (b.thuTu || 0));
            setDsNhomNhanSu(data);
        } catch (e) {
            toast.error("Không thể tải danh mục nhóm nhân sự");
        }
    };

    useEffect(() => {
        setLoading(true);
        loadNhomNhanSu();
        const params = new URLSearchParams(window.location.search)
        let id = params.get('id') || '';
        if (parseInt(id) > 0) {
            setIdBaoHiem(parseInt(id));
        };
        setLoading(false);
    }, []);

    useEffect(() => {
        setLoading(true);
        setTuKhoa("");
        setSearchQuery("");
        if (idBaoHiem > 0) {
            timKiemBaoHiem(idBaoHiem);
        }
        setLoading(false);

    }, [idBaoHiem]);

    useEffect(() => {
        var congDoan = 0;
        var nld = 0;
        var nsd = 0;
        for (var i = 0; i < (danhSachChiTiet || []).length; i++) {
            var ct = danhSachChiTiet[i];
            nld += ct.nlD_BHTN + ct.nlD_BHXH + ct.nlD_BHYT;
            nsd += ct.dV_BHTN + ct.dV_BHXH + ct.dV_BHYT;
            congDoan += ct.congDoan;
        }

        setTotalDV(nsd);
        setTotalLD(nld);
        setTotalCD(congDoan);
        setTotal(nsd + nld);
    }, [danhSachChiTiet]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            search();
        }
    };

    useEffect(() => {
        if (reloadPage) {
            setReloadPage(false);
        }
    }, [reloadPage]);

    const filteredDanhSach = (danhSachChiTiet || []).filter(item => {
        if (!searchQuery) return true;
        const q = searchQuery.toLowerCase().trim();
        return (
            item.hoTen?.toLowerCase().includes(q) ||
            item.ma?.toLowerCase().includes(q) ||
            item.chucVu?.toLowerCase().includes(q)
        );
    });

    const componentRef = React.createRef<any>();

    const printBHXH = useReactToPrint({
        content: () => componentRef.current,
    });
    return (
        <>
        <section >
            <ContentHeader title={baoHiem?.loaiBaoHiemThang === 1 ? "Bổ sung, điều chỉnh BHXH" : "Bảo hiểm xã hội"} />
                <Row className="form-group" gutter={8}>
                    <Col xs={{ span: 0 }} sm={{ span: 0 }} md={3}>
                        <Input style={{ marginTop: '5px'}} value={`Tháng ${dateCommon.formatDate(baoHiem?.thangNam, "MM/yyyy")}`} readOnly />
                    </Col>
                    <Col xs={5} sm={4} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 0 }}>
                        <Input style={{ marginTop: '5px'}} value={dateCommon.formatDate(baoHiem?.thangNam, "MM/yyyy")} readOnly />
                    </Col>
                    <Col xs={17} sm={18} md={6}>
                        <Input style={{ marginTop: '5px'}} prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên" onChange={(e) => setTuKhoa(e.target.value)}
                            onKeyPress={handleKeyPress}/>
                    </Col>
                    <Col xs={2} sm={2} md={{ span: 0 }} lg={{ span: 0 }} xl={{ span: 0 }}>
                        <Space>
                            <Button style={{ marginTop: '7px' }} type="primary" icon={<SearchOutlined rev="" />} onClick={search}></Button>
                        </Space>
                    </Col>
                    <Col xs={{ span: 0 }} sm={{ span: 0 }} md={10} >
                        <Space>
                            <Button style={{ marginTop: '5px' }} type="primary" icon={<SearchOutlined rev="" />} onClick={search}> Tìm kiếm
                            </Button>
                            <Button style={{ marginTop: '5px' }} className="hrm-btn hrm-btn-success" onClick={handleExport} icon={<DownloadOutlined rev="" />} hidden={window.innerWidth <= 940}>
                                Xuất excel
                            </Button>
                            {(baoHiem?.trangThai || 0) === 0 && (
                                <Button style={{ marginTop: '5px' }} className="hrm-btn hrm-btn-primary" onClick={() => setIsShowImportModal(true)} icon={<UploadOutlined rev="" />}>
                                    Import excel
                                </Button>
                            )}
                            </Space>
                    </Col>
                    <Col xs={24} sm={24} md={5}>
                        <Space className="float-right" style={{ marginTop: '5px' }}>
                            <Button type="default" className="hrm-btn float-right hrm-btn-warning" icon={<ArrowLeftOutlined />} onClick={() => { navigate(Links.BaoHiem.DanhSach) }}>
                                Quay lại
                            </Button>
                            <Button 
                                type="default" 
                                className="hrm-btn float-right hrm-btn-primary" 
                                icon={isCollapsed ? <ExpandOutlined /> : <CompressOutlined />} 
                                onClick={() => setIsCollapsed(!isCollapsed)}
                            >
                                {isCollapsed ? "Mở rộng" : "Thu gọn"}
                            </Button>
                            {    
                                (baoHiem?.trangThai || 0) === 0 &&
                                <Button type="primary" onClick={handleLoadData} icon={<DownloadOutlined rev="" />}>
                                    Tính BHXH
                                </Button>
                            }        
                                {
                                    (baoHiem?.trangThai || 0) === 0 &&
                                    <Button type="primary" onClick={() => setIsShowModal(true)} icon={<SendOutlined rev="" />}>
                                        Xác nhận
                                    </Button>
                                }
                        
                                {
                                    (baoHiem?.trangThai || 0) === 0 &&
                                        <Button className="hrm-btn float-right hrm-btn-warning" onClick={() => {
                                            handleSaveData();
                                        }} icon={<SaveOutlined rev="" />}>
                                        Lưu
                                    </Button>
                                }
                            </Space>
                    </Col>
                </Row >
                <div style={{ display: isCollapsed ? 'none' : 'block' }}>
                    <Row gutter={8}>
                        <Col span={6}>
                            <Card bordered={false} size='small' style={{ width: '100%', padding: '10px', marginBottom: '1vh', }}>
                                <Row gutter={15}>
                                    <Col className=' text-center'>
                                        Tổng tiền BH <br />phải nộp
                                    </Col>
                                    <Col className='text-bold align-self-center'>
                                        {formatVND(total)}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card bordered={false} size='small' style={{ width: '100%', padding: '10px', marginBottom: '1vh', }}>
                                <Row gutter={15}>
                                    <Col className=' text-center'>
                                        Người lao động<br />chi trả
                                    </Col>
                                    <Col className='text-bold align-self-center '>
                                        {formatVND(totalLD)}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card bordered={false} size='small' style={{ width: '100%', padding: '10px', marginBottom: '1vh', }}>
                                <Row gutter={15}>
                                    <Col className=' text-center'>
                                        Người sử dụng <br />lao động chi trả
                                    </Col>
                                    <Col className='text-bold align-self-center '>
                                        {formatVND(totalDV)}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col span={6}>
                            <Card bordered={false} size='small' style={{ width: '100%', padding: '21px 10px 21px 10px', marginBottom: '1vh', }}>
                                <Row gutter={15}>
                                    <Col className=' text-center'>
                                        Kinh phí công đoàn <br />
                                    </Col>
                                    <Col className='text-bold align-self-center '>
                                        {formatVND(totalCD)}
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={8} style={{ marginBottom: '2vh' }}>
                        <Col span={24}>
                            <Card title="Ghi chú bảo hiểm tháng" size="small">
                                {(baoHiem?.trangThai || 0) !== 0 ? (
                                    <div style={{ whiteSpace: 'pre-wrap', padding: '8px', minHeight: '40px', background: '#f5f5f5', borderRadius: '4px', border: '1px solid #d9d9d9' }}>
                                        {ghiChu || <span style={{ color: '#bfbfbf', fontStyle: 'italic' }}>Không có ghi chú</span>}
                                    </div>
                                ) : (
                                    <Input.TextArea
                                        rows={3}
                                        placeholder="Nhập ghi chú cho bảng bảo hiểm tháng..."
                                        value={ghiChu}
                                        onChange={(e) => setGhiChu(e.target.value)}
                                    />
                                )}
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Row >
                    <Col span="24">
                        <div className="card-outline" style={{ padding: '16px', background: 'white' }}>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                                <Space>
                                    {baoHiem?.loaiBaoHiemThang === 0 ? null : (
                                        (baoHiem?.trangThai || 0) === 0 &&
                                        <>
                                            <Button
                                                className="hrm-btn hrm-btn-warning"
                                                onClick={() => {
                                                    setShowModalDSNV('NQL');
                                                }}
                                                icon={<PlusOutlined rev="" />}
                                            >
                                                Thêm người quản lý
                                            </Button>
                                            <Button
                                                className="hrm-btn hrm-btn-warning"
                                                onClick={() => {
                                                    setShowModalDSNV('NLD');
                                                }}
                                                icon={<PlusOutlined rev="" />}
                                            >
                                                Thêm người lao động
                                            </Button>
                                        </>
                                    )}
                                    {
                                        (baoHiem?.trangThai || 0) === 0 &&
                                        <Button
                                            style={{ width: '140px' }}
                                            type="default" onClick={() => setIsEdit(!isEdit)}
                                                icon={isEdit ? <LockOutlined rev="" style={{ color: 'red' }} /> : <EditOutlined rev="" style={{ color: '#007bff' }} />}
                                        >{isEdit ? "Khóa" : "Điều chỉnh"}
                                        </Button>
                                    }
                                    <Button
                                        hidden={window.innerWidth <= 576}
                                        className="hrm-btn-print"
                                        icon={<PrinterOutlined rev=""/>}
                                        onClick={() => {
                                            printBHXH();
                                        }}
                                    >
                                        In Báo cáo
                                    </Button>
                                </Space>
                            </div>
                            <TableBaoHiem dataSource={filteredDanhSach} loading={loading} loaiBaoHiemThang={baoHiem?.loaiBaoHiemThang} isEdit={isEdit} dsNhomNhanSu={dsNhomNhanSu} onChange={(d) => {
                                setDanhSachChiTiet([...d]);
                            }} />
                        </div>
                    </Col>
                </Row>
                {showModalDSNV ? <NhanSuNopBaoHiemTableModal id={idBaoHiem} isQuanLy={showModalDSNV === 'NQL'} hide={() => { setShowModalDSNV(null); }} onSubmit={onSubmitNhanVienTableModal} /> : null}
            <ModalTextForm
                show={isShowModal}
                title={"Bảo hiểm xã hội"}
                handleClose={() => setIsShowModal(false)}
                handleSave={() => {
                    setIsShowModal(false);
                    duyetBHXHThang();
                }}
            >
                Bạn có muốn chốt BHXH hay không
            </ModalTextForm>
            <Modal
                title={
                    <Space>
                        <FileExcelOutlined style={{ color: '#217346', fontSize: 18 }} />
                        <span>Import dữ liệu Bảo hiểm xã hội</span>
                    </Space>
                }
                open={isShowImportModal}
                onCancel={() => {
                    setIsShowImportModal(false);
                    setFileUpload(null);
                }}
                footer={[
                    <Button
                        key="back"
                        onClick={() => {
                            setIsShowImportModal(false);
                            setFileUpload(null);
                        }}
                    >
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!fileUpload}
                        icon={<UploadOutlined />}
                        onClick={handleImportExcel}
                    >
                        Tải lên
                    </Button>,
                ]}
                destroyOnClose
                centered
            >
                <div style={{ padding: '8px 0' }}>
                    <Dropzone
                        maxFiles={1}
                        multiple={false}
                        accept={{
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                            'application/vnd.ms-excel': ['.xls'],
                        }}
                        onDrop={(acceptedFiles) => {
                            if (acceptedFiles && acceptedFiles.length > 0) {
                                setFileUpload(acceptedFiles[0]);
                            }
                        }}
                    >
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps()}
                                className="hrm-dropzone-uploadfile"
                                style={{
                                    padding: '28px 16px',
                                    background: isDragActive ? '#e6f4ff' : '#fafafa',
                                    borderColor: isDragActive ? '#1677ff' : fileUpload ? '#28a745' : '#d9d9d9',
                                    borderRadius: 8,
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#1677ff', margin: 0 }}>
                                            Thả tệp Excel vào đây...
                                        </p>
                                    </div>
                                ) : fileUpload ? (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <FileExcelOutlined style={{ color: '#217346', fontSize: 40 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 600, color: '#262626', margin: '0 0 4px 0', wordBreak: 'break-all' }}>
                                            {fileUpload.name}
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: '0 0 8px 0' }}>
                                            Kích thước: {(fileUpload.size / 1024).toFixed(1)} KB
                                        </p>
                                        <Button
                                            size="small"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setFileUpload(null);
                                            }}
                                        >
                                            Chọn tệp khác
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <p style={{ marginBottom: 8 }}>
                                            <InboxOutlined style={{ color: '#1677ff', fontSize: 42 }} />
                                        </p>
                                        <p style={{ fontSize: 14, fontWeight: 500, color: '#262626', margin: '0 0 4px 0' }}>
                                            Nhấp hoặc kéo thả tệp Excel vào đây để tải lên
                                        </p>
                                        <p style={{ fontSize: 12, color: '#8c8c8c', margin: 0 }}>
                                            Hỗ trợ định dạng tệp .xlsx, .xls
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                    </Dropzone>
                </div>
            </Modal>
        </section >
        {
        danhSachChiTiet.length > 0 &&
        <section style={{ display: 'none' }} >
            <div ref={componentRef}>
                 <PrintBHXH dataSource={danhSachChiTiet} namThang={baoHiem?.thangNam} thangNamTitle={`Tháng ${dateCommon.formatDate(baoHiem?.thangNam, "MM")} năm ${dateCommon.formatDate(baoHiem?.thangNam, "yyyy")}`} dsNhomNhanSu={dsNhomNhanSu} ></PrintBHXH>
            </div>
        </section>
        }
    </>
    )
}

export default XemChiTietBaoHiem;